import { MultiMediaBasicInfo } from "../MultiMediaBasicInfo";
import { SourceBase } from "./source-base";
import { Multimedia } from '../multimedia/multimedia';

export class SourceComponentModel extends SourceBase{
    multimedias: Multimedia[]; 
}